import {StyleProp, View, ViewStyle} from 'react-native';
import {styles} from './styles';

interface BoxShadowedProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}
export const BoxShadowed = ({children, style}: BoxShadowedProps) => {
  return <View style={[styles.BoxShadowedContainer, style]}>{children}</View>;
};
